import { Word } from '@/common/types/scopeAndSequence';
import {
  GameInstance,
  getStudent,
} from '@/game/GameComponents/PhaserGame/GameInstance';
import { StudentGameInputHandler } from '@/game/GameComponents/PhaserGame/Input/StudentGameInputHandler';
import {
  getAssessmentWords,
  getScreenerWords,
} from '@/game/prefabs/Assessment/assessmentHelpers';
import CardDropSite from '@/game/prefabs/StudentGame/CardDropSite';
import StudentGameCard from '@/game/prefabs/StudentGame/StudentGameCard';
import { AssessmentUIController } from '@/game/scenes/Assessment/AssessmentUIController';
import _ from 'lodash';

/* START OF COMPILED CODE */

import { ControllerType } from '@/common/types/student';
import StudentGame from '../../GameComponents/PhaserGame/StudentGames/StudentGame';
import SwitchControlsModal from '../../prefabs/Assessment/SwitchControlsModal';
import DefaultButton from '../../prefabs/GeneralUI/Buttons/DefaultButton';
import HUDButton from '../../prefabs/GeneralUI/Buttons/HUDButton';
import DefinitionExampleView from '../../prefabs/GeneralUI/DefinitionExampleView';
import UIBlocker from '../../prefabs/GeneralUI/UIBlocker';
import PlayerTypingInput from '../../prefabs/StudentGame/PlayerTypingInput';
import SequencedCardDropSite from '../../prefabs/StudentGame/SequencedCardDropSite';
import QuitToMenuModal from '../../prefabs/WorldUI/QuitToMenuModal';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class AssessmentUI extends StudentGame {
  constructor() {
    super('AssessmentUI');

    /* START-USER-CTR-CODE */

    this._controller = new AssessmentUIController(this);

    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // desktopView
    const desktopView = this.add.container(0, 0);

    // progress
    const progress = this.add.container(0, 0);
    progress.visible = false;
    desktopView.add(progress);

    // progressBarBacking
    const progressBarBacking = this.add.image(0, 8, '1x1sprite');
    progressBarBacking.scaleX = 1024;
    progressBarBacking.scaleY = 16;
    progressBarBacking.setOrigin(0, 0.5);
    progressBarBacking.tintTopLeft = 5387071;
    progressBarBacking.tintTopRight = 5387071;
    progressBarBacking.tintBottomLeft = 5387071;
    progressBarBacking.tintBottomRight = 5387071;
    progress.add(progressBarBacking);

    // progressBarFill
    const progressBarFill = this.add.image(0, 8, '1x1sprite');
    progressBarFill.scaleX = 0;
    progressBarFill.scaleY = 16;
    progressBarFill.setOrigin(0, 0.5);
    progressBarFill.tintTopLeft = 15091001;
    progressBarFill.tintTopRight = 15091001;
    progressBarFill.tintBottomLeft = 15091001;
    progressBarFill.tintBottomRight = 15091001;
    progress.add(progressBarFill);

    // userButtons
    const userButtons = this.add.container(800, 1024);
    desktopView.add(userButtons);

    // userControls
    const userControls = this.add.container(0, -56);
    userButtons.add(userControls);

    // nineslice_2
    const nineslice_2 = this.add.nineslice(
      0,
      -28,
      'Hud3',
      undefined,
      92,
      36,
      10,
      10,
      10,
      10,
    );
    nineslice_2.scaleX = 4;
    nineslice_2.scaleY = 4;
    userControls.add(nineslice_2);

    // submitButton
    const submitButton = new DefaultButton(this, 0, -60);
    userControls.add(submitButton);

    // helperButtons
    const helperButtons = this.add.container(0, 0);
    helperButtons.scaleX = 2;
    helperButtons.scaleY = 2;
    userControls.add(helperButtons);

    // repeatInstructionButton
    const repeatInstructionButton = new HUDButton(
      this,
      40,
      0,
      'ui-repeat-button',
    );
    repeatInstructionButton.scaleX = 2;
    repeatInstructionButton.scaleY = 2;
    helperButtons.add(repeatInstructionButton);

    // playDefinitionButton
    const playDefinitionButton = new HUDButton(
      this,
      0,
      0,
      'ui-definition-button',
    );
    playDefinitionButton.scaleX = 2;
    playDefinitionButton.scaleY = 2;
    helperButtons.add(playDefinitionButton);

    // playWordInSentenceButton
    const playWordInSentenceButton = new HUDButton(
      this,
      -36,
      0,
      'ui-speak-button',
    );
    playWordInSentenceButton.scaleX = 2;
    playWordInSentenceButton.scaleY = 2;
    helperButtons.add(playWordInSentenceButton);

    // handArea
    const handArea = this.add.container(800, 1020);
    desktopView.add(handArea);

    // handDropSite
    const handDropSite = new SequencedCardDropSite(this, 0, -232);
    handArea.add(handDropSite);

    // handDropZoneOverride
    const handDropZoneOverride = this.add.image(0, -168, '1x1sprite');
    handDropZoneOverride.scaleX = 1600;
    handDropZoneOverride.scaleY = 250;
    handDropZoneOverride.alpha = 0;
    handDropZoneOverride.alphaTopLeft = 0;
    handDropZoneOverride.alphaTopRight = 0;
    handDropZoneOverride.alphaBottomLeft = 0;
    handDropZoneOverride.alphaBottomRight = 0;
    handArea.add(handDropZoneOverride);

    // boardArea
    const boardArea = this.add.container(800, 1020);
    desktopView.add(boardArea);

    // typingView
    const typingView = this.add.container(0, -232);
    boardArea.add(typingView);

    // playerTypingInput
    const playerTypingInput = new PlayerTypingInput(this, 0, 0);
    typingView.add(playerTypingInput);

    // cardView
    const cardView = this.add.container(0, -392);
    boardArea.add(cardView);

    // dropSiteBacking
    const dropSiteBacking = this.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      256,
      40,
      10,
      10,
      10,
      10,
    );
    dropSiteBacking.scaleX = 4;
    dropSiteBacking.scaleY = 4;
    dropSiteBacking.visible = false;
    cardView.add(dropSiteBacking);

    // boardDropSite
    const boardDropSite = new SequencedCardDropSite(this, 0, 0);
    boardDropSite.visible = true;
    cardView.add(boardDropSite);

    // AssessmentOptionsContainer
    const assessmentOptionsContainer = this.add.container(1024, 0);
    assessmentOptionsContainer.scaleX = 2;
    assessmentOptionsContainer.scaleY = 2;
    desktopView.add(assessmentOptionsContainer);

    // nineslice
    const nineslice = this.add.nineslice(
      -8,
      8,
      'Hud3',
      undefined,
      70,
      24,
      12,
      12,
      12,
      12,
    );
    nineslice.scaleX = 2;
    nineslice.scaleY = 2;
    nineslice.setOrigin(1, 0);
    assessmentOptionsContainer.add(nineslice);

    // quitButton
    const quitButton = new HUDButton(this, -40, 32, 'exit1');
    quitButton.scaleX = 2;
    quitButton.scaleY = 2;
    assessmentOptionsContainer.add(quitButton);

    // helpButton
    const helpButton = new HUDButton(this, -76, 32, 'help3');
    helpButton.scaleX = 2;
    helpButton.scaleY = 2;
    helpButton.visible = true;
    assessmentOptionsContainer.add(helpButton);

    // switchControlsButton
    const switchControlsButton = new HUDButton(
      this,
      -112,
      32,
      'KeyboardClick1',
    );
    switchControlsButton.scaleX = 2;
    switchControlsButton.scaleY = 2;
    switchControlsButton.visible = true;
    assessmentOptionsContainer.add(switchControlsButton);

    // helpContainer
    const helpContainer = this.add.container(-152, 8);
    helpContainer.scaleX = 0.5;
    helpContainer.scaleY = 0.5;
    assessmentOptionsContainer.add(helpContainer);

    // nineslice_1
    const nineslice_1 = this.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      64,
      36,
      4,
      4,
      4,
      8,
    );
    nineslice_1.scaleX = 4;
    nineslice_1.scaleY = 4;
    nineslice_1.setOrigin(1, 0);
    helpContainer.add(nineslice_1);

    // switchContextButton
    const switchContextButton = new DefaultButton(this, -128, 104);
    helpContainer.add(switchContextButton);

    // switchToMousePrompt
    const switchToMousePrompt = this.add.container(-240, 16);
    helpContainer.add(switchToMousePrompt);

    // bitmaptext_1
    const bitmaptext_1 = this.add.bitmapText(
      0,
      0,
      'Aronui',
      "Don't have a keyboard? Press the button below to switch to letter tiles:",
    );
    bitmaptext_1.tintTopLeft = 5387071;
    bitmaptext_1.tintTopRight = 5387071;
    bitmaptext_1.tintBottomLeft = 5387071;
    bitmaptext_1.tintBottomRight = 5387071;
    bitmaptext_1.text =
      "Don't have a keyboard? Press the button below to switch to letter tiles:";
    bitmaptext_1.fontSize = -14;
    bitmaptext_1.maxWidth = 220;
    switchToMousePrompt.add(bitmaptext_1);

    // switchToKeyboardPrompt
    const switchToKeyboardPrompt = this.add.container(-240, 16);
    helpContainer.add(switchToKeyboardPrompt);

    // bitmaptext
    const bitmaptext = this.add.bitmapText(
      0,
      0,
      'Aronui',
      'Want to type your answers? Press the button to switch to keyboard:',
    );
    bitmaptext.tintTopLeft = 5387071;
    bitmaptext.tintTopRight = 5387071;
    bitmaptext.tintBottomLeft = 5387071;
    bitmaptext.tintBottomRight = 5387071;
    bitmaptext.text =
      'Want to type your answers? Press the button to switch to keyboard:';
    bitmaptext.fontSize = -14;
    bitmaptext.maxWidth = 220;
    switchToKeyboardPrompt.add(bitmaptext);

    // settingsButton
    const settingsButton = new HUDButton(this, -74, 32, 'hud-icons', 131);
    settingsButton.scaleX = 2;
    settingsButton.scaleY = 2;
    settingsButton.visible = false;
    assessmentOptionsContainer.add(settingsButton);

    // autocompleteAssessmentButton
    const autocompleteAssessmentButton = new HUDButton(
      this,
      -26,
      74,
      'hud-icons',
      132,
    );
    assessmentOptionsContainer.add(autocompleteAssessmentButton);

    // clickPrompt
    const clickPrompt = this.add.container(0, 0);
    clickPrompt.visible = false;
    desktopView.add(clickPrompt);

    // visualBacking_1
    const visualBacking_1 = this.add.image(0, 0, '1x1sprite');
    visualBacking_1.scaleX = 1024;
    visualBacking_1.scaleY = 768;
    visualBacking_1.setOrigin(0, 0);
    visualBacking_1.tintTopLeft = 985612;
    visualBacking_1.tintTopRight = 985612;
    visualBacking_1.tintBottomLeft = 985612;
    visualBacking_1.tintBottomRight = 985612;
    clickPrompt.add(visualBacking_1);

    // uIBlocker_2
    const uIBlocker_2 = new UIBlocker(this, 0, 0);
    clickPrompt.add(uIBlocker_2);

    // clickContainer
    const clickContainer = this.add.container(512, 384);
    clickPrompt.add(clickContainer);

    // clickText
    const clickText = this.add.bitmapText(
      0,
      -176,
      'Aronui',
      'Click on the letters to create the word',
    );
    clickText.setOrigin(0.5, 0.5);
    clickText.tintTopLeft = 15091001;
    clickText.tintTopRight = 15091001;
    clickText.tintBottomLeft = 15091001;
    clickText.tintBottomRight = 15091001;
    clickText.text = 'Click on the letters to create the word';
    clickText.fontSize = -30;
    clickContainer.add(clickText);

    // startButton2
    const startButton2 = new DefaultButton(this, 0, 184);
    clickContainer.add(startButton2);

    // switchContainer_1
    const switchContainer_1 = this.add.container(1024, 768);
    clickPrompt.add(switchContainer_1);

    // switchprompt_1
    const switchprompt_1 = this.add.bitmapText(
      -472,
      -60,
      'Aronui',
      'Want to type your answers?\nClick here to switch to keyboard:',
    );
    switchprompt_1.tintTopLeft = 15130076;
    switchprompt_1.tintTopRight = 15130076;
    switchprompt_1.tintBottomLeft = 15130076;
    switchprompt_1.tintBottomRight = 15130076;
    switchprompt_1.text =
      'Want to type your answers?\nClick here to switch to keyboard:';
    switchprompt_1.fontSize = -16;
    switchContainer_1.add(switchprompt_1);

    // switchToKeyboardButton
    const switchToKeyboardButton = new DefaultButton(this, -112, -44);
    switchContainer_1.add(switchToKeyboardButton);

    // keyboardPrompt
    const keyboardPrompt = this.add.container(0, 0);
    keyboardPrompt.visible = false;
    desktopView.add(keyboardPrompt);

    // visualBacking
    const visualBacking = this.add.image(0, 0, '1x1sprite');
    visualBacking.scaleX = 1024;
    visualBacking.scaleY = 768;
    visualBacking.setOrigin(0, 0);
    visualBacking.tintTopLeft = 985612;
    visualBacking.tintTopRight = 985612;
    visualBacking.tintBottomLeft = 985612;
    visualBacking.tintBottomRight = 985612;
    keyboardPrompt.add(visualBacking);

    // uIBlocker_1
    const uIBlocker_1 = new UIBlocker(this, 0, 0);
    keyboardPrompt.add(uIBlocker_1);

    // keyboardContainer
    const keyboardContainer = this.add.container(512, 384);
    keyboardPrompt.add(keyboardContainer);

    // keyboard-image
    const keyboard_image = this.add.image(0, 0, 'keyboard');
    keyboardContainer.add(keyboard_image);

    // keyboard-text
    const keyboard_text = this.add.bitmapText(
      0,
      -176,
      'Aronui',
      'Type your answers on the keyboard',
    );
    keyboard_text.setOrigin(0.5, 0.5);
    keyboard_text.alpha = 0.65;
    keyboard_text.alphaTopLeft = 0.65;
    keyboard_text.alphaTopRight = 0.65;
    keyboard_text.alphaBottomLeft = 0.65;
    keyboard_text.alphaBottomRight = 0.65;
    keyboard_text.tintTopLeft = 15091001;
    keyboard_text.tintTopRight = 15091001;
    keyboard_text.tintBottomLeft = 15091001;
    keyboard_text.tintBottomRight = 15091001;
    keyboard_text.text = 'Type your answers on the keyboard';
    keyboard_text.fontSize = -30;
    keyboardContainer.add(keyboard_text);

    // startButton1
    const startButton1 = new DefaultButton(this, 0, 184);
    keyboardContainer.add(startButton1);

    // switchContainer
    const switchContainer = this.add.container(1024, 768);
    keyboardPrompt.add(switchContainer);

    // switchprompt
    const switchprompt = this.add.bitmapText(
      -472,
      -60,
      'Aronui',
      "Don't have a keyboard?\nClick here to switch to letter cards:",
    );
    switchprompt.tintTopLeft = 15130076;
    switchprompt.tintTopRight = 15130076;
    switchprompt.tintBottomLeft = 15130076;
    switchprompt.tintBottomRight = 15130076;
    switchprompt.text =
      "Don't have a keyboard?\nClick here to switch to letter cards:";
    switchprompt.fontSize = -16;
    switchContainer.add(switchprompt);

    // switchToMouseButton
    const switchToMouseButton = new DefaultButton(this, -112, -44);
    switchContainer.add(switchToMouseButton);

    // quitToMenuModal
    const quitToMenuModal = new QuitToMenuModal(this, 0, 0);
    quitToMenuModal.visible = false;
    desktopView.add(quitToMenuModal);

    // switchControlsModal
    const switchControlsModal = new SwitchControlsModal(this, 0, 0);
    desktopView.add(switchControlsModal);

    // definitionExampleView
    const definitionExampleView = new DefinitionExampleView(this, 0, 0);
    desktopView.add(definitionExampleView);

    // mobileView
    const mobileView = this.add.container(0, 0);
    mobileView.visible = false;

    // progress_m
    const progress_m = this.add.container(0, 0);
    progress_m.visible = false;
    mobileView.add(progress_m);

    // progressBarBacking_m
    const progressBarBacking_m = this.add.image(0, 8, '1x1sprite');
    progressBarBacking_m.scaleX = 1024;
    progressBarBacking_m.scaleY = 16;
    progressBarBacking_m.setOrigin(0, 0.5);
    progressBarBacking_m.tintTopLeft = 5387071;
    progressBarBacking_m.tintTopRight = 5387071;
    progressBarBacking_m.tintBottomLeft = 5387071;
    progressBarBacking_m.tintBottomRight = 5387071;
    progress_m.add(progressBarBacking_m);

    // progressBarFill_m
    const progressBarFill_m = this.add.image(0, 8, '1x1sprite');
    progressBarFill_m.scaleX = 0;
    progressBarFill_m.scaleY = 16;
    progressBarFill_m.setOrigin(0, 0.5);
    progressBarFill_m.tintTopLeft = 15091001;
    progressBarFill_m.tintTopRight = 15091001;
    progressBarFill_m.tintBottomLeft = 15091001;
    progressBarFill_m.tintBottomRight = 15091001;
    progress_m.add(progressBarFill_m);

    // userButtons_m
    const userButtons_m = this.add.container(339, 375);
    userButtons_m.scaleX = 0.75;
    userButtons_m.scaleY = 0.75;
    mobileView.add(userButtons_m);

    // userControls_m
    const userControls_m = this.add.container(0, -56);
    userButtons_m.add(userControls_m);

    // nineslice_2_m
    const nineslice_2_m = this.add.nineslice(
      0,
      -28,
      'Hud3',
      undefined,
      92,
      36,
      10,
      10,
      10,
      10,
    );
    nineslice_2_m.scaleX = 4;
    nineslice_2_m.scaleY = 4;
    userControls_m.add(nineslice_2_m);

    // submitButton_m
    const submitButton_m = new DefaultButton(this, 0, -60);
    userControls_m.add(submitButton_m);

    // helperButtons_m
    const helperButtons_m = this.add.container(0, 0);
    helperButtons_m.scaleX = 2;
    helperButtons_m.scaleY = 2;
    userControls_m.add(helperButtons_m);

    // repeatInstructionButton_m
    const repeatInstructionButton_m = new HUDButton(
      this,
      40,
      0,
      'ui-repeat-button',
    );
    repeatInstructionButton_m.scaleX = 2;
    repeatInstructionButton_m.scaleY = 2;
    helperButtons_m.add(repeatInstructionButton_m);

    // playDefinitionButton_m
    const playDefinitionButton_m = new HUDButton(
      this,
      0,
      0,
      'ui-definition-button',
    );
    playDefinitionButton_m.scaleX = 2;
    playDefinitionButton_m.scaleY = 2;
    helperButtons_m.add(playDefinitionButton_m);

    // playWordInSentenceButton_m
    const playWordInSentenceButton_m = new HUDButton(
      this,
      -36,
      0,
      'ui-speak-button',
    );
    playWordInSentenceButton_m.scaleX = 2;
    playWordInSentenceButton_m.scaleY = 2;
    helperButtons_m.add(playWordInSentenceButton_m);

    // handArea_m
    const handArea_m = this.add.container(340, 375);
    handArea_m.scaleX = 0.75;
    handArea_m.scaleY = 0.75;
    mobileView.add(handArea_m);

    // handDropSite_m
    const handDropSite_m = new SequencedCardDropSite(this, 0, -79);
    handArea_m.add(handDropSite_m);

    // handDropZoneOverride_m
    const handDropZoneOverride_m = this.add.image(0, -63, '1x1sprite');
    handDropZoneOverride_m.scaleX = 1600;
    handDropZoneOverride_m.scaleY = 125;
    handDropZoneOverride_m.alpha = 0;
    handDropZoneOverride_m.alphaTopLeft = 0;
    handDropZoneOverride_m.alphaTopRight = 0;
    handDropZoneOverride_m.alphaBottomLeft = 0;
    handDropZoneOverride_m.alphaBottomRight = 0;
    handArea_m.add(handDropZoneOverride_m);

    // boardArea_m
    const boardArea_m = this.add.container(334, 376);
    boardArea_m.scaleX = 0.75;
    boardArea_m.scaleY = 0.75;
    mobileView.add(boardArea_m);

    // typingView_m
    const typingView_m = this.add.container(3, -235);
    boardArea_m.add(typingView_m);

    // playerTypingInput_m
    const playerTypingInput_m = new PlayerTypingInput(this, 0, 0);
    typingView_m.add(playerTypingInput_m);

    // cardView_m
    const cardView_m = this.add.container(3, -235);
    boardArea_m.add(cardView_m);

    // dropSiteBacking_m
    const dropSiteBacking_m = this.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      256,
      40,
      10,
      10,
      10,
      10,
    );
    dropSiteBacking_m.scaleX = 4;
    dropSiteBacking_m.scaleY = 4;
    dropSiteBacking_m.visible = false;
    cardView_m.add(dropSiteBacking_m);

    // boardDropSite_m
    const boardDropSite_m = new SequencedCardDropSite(this, 0, 0);
    boardDropSite_m.visible = true;
    cardView_m.add(boardDropSite_m);

    // AssessmentOptionsContainer_m
    const assessmentOptionsContainer_m = this.add.container(680, 0);
    assessmentOptionsContainer_m.scaleX = 1.5;
    assessmentOptionsContainer_m.scaleY = 1.5;
    mobileView.add(assessmentOptionsContainer_m);

    // nineslice_m
    const nineslice_m = this.add.nineslice(
      -8,
      8,
      'Hud3',
      undefined,
      70,
      24,
      12,
      12,
      12,
      12,
    );
    nineslice_m.scaleX = 2;
    nineslice_m.scaleY = 2;
    nineslice_m.setOrigin(1, 0);
    assessmentOptionsContainer_m.add(nineslice_m);

    // quitButton_m
    const quitButton_m = new HUDButton(this, -40, 32, 'exit1');
    quitButton_m.scaleX = 2;
    quitButton_m.scaleY = 2;
    assessmentOptionsContainer_m.add(quitButton_m);

    // helpButton_m
    const helpButton_m = new HUDButton(this, -76, 32, 'help3');
    helpButton_m.scaleX = 2;
    helpButton_m.scaleY = 2;
    helpButton_m.visible = true;
    assessmentOptionsContainer_m.add(helpButton_m);

    // switchControlsButton_m
    const switchControlsButton_m = new HUDButton(
      this,
      -112,
      32,
      'KeyboardClick1',
    );
    switchControlsButton_m.scaleX = 2;
    switchControlsButton_m.scaleY = 2;
    switchControlsButton_m.visible = true;
    assessmentOptionsContainer_m.add(switchControlsButton_m);

    // helpContainer_m
    const helpContainer_m = this.add.container(-152, 8);
    helpContainer_m.scaleX = 0.5;
    helpContainer_m.scaleY = 0.5;
    assessmentOptionsContainer_m.add(helpContainer_m);

    // nineslice_1_m
    const nineslice_1_m = this.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      64,
      36,
      4,
      4,
      4,
      8,
    );
    nineslice_1_m.scaleX = 4;
    nineslice_1_m.scaleY = 4;
    nineslice_1_m.setOrigin(1, 0);
    helpContainer_m.add(nineslice_1_m);

    // switchContextButton_m
    const switchContextButton_m = new DefaultButton(this, -128, 104);
    helpContainer_m.add(switchContextButton_m);

    // switchToMousePrompt_m
    const switchToMousePrompt_m = this.add.container(-240, 16);
    helpContainer_m.add(switchToMousePrompt_m);

    // bitmaptext_1_m
    const bitmaptext_1_m = this.add.bitmapText(
      0,
      0,
      'Aronui',
      "Don't have a keyboard? Press the button below to switch to letter tiles:",
    );
    bitmaptext_1_m.tintTopLeft = 5387071;
    bitmaptext_1_m.tintTopRight = 5387071;
    bitmaptext_1_m.tintBottomLeft = 5387071;
    bitmaptext_1_m.tintBottomRight = 5387071;
    bitmaptext_1_m.text =
      "Don't have a keyboard? Press the button below to switch to letter tiles:";
    bitmaptext_1_m.fontSize = -14;
    bitmaptext_1_m.maxWidth = 220;
    switchToMousePrompt_m.add(bitmaptext_1_m);

    // switchToKeyboardPrompt_m
    const switchToKeyboardPrompt_m = this.add.container(-240, 16);
    helpContainer_m.add(switchToKeyboardPrompt_m);

    // bitmaptext_m
    const bitmaptext_m = this.add.bitmapText(
      0,
      0,
      'Aronui',
      'Want to type your answers? Press the button to switch to keyboard:',
    );
    bitmaptext_m.tintTopLeft = 5387071;
    bitmaptext_m.tintTopRight = 5387071;
    bitmaptext_m.tintBottomLeft = 5387071;
    bitmaptext_m.tintBottomRight = 5387071;
    bitmaptext_m.text =
      'Want to type your answers? Press the button to switch to keyboard:';
    bitmaptext_m.fontSize = -14;
    bitmaptext_m.maxWidth = 220;
    switchToKeyboardPrompt_m.add(bitmaptext_m);

    // settingsButton_m
    const settingsButton_m = new HUDButton(this, -74, 32, 'hud-icons', 131);
    settingsButton_m.scaleX = 2;
    settingsButton_m.scaleY = 2;
    settingsButton_m.visible = false;
    assessmentOptionsContainer_m.add(settingsButton_m);

    // autocompleteAssessmentButton_m
    const autocompleteAssessmentButton_m = new HUDButton(
      this,
      -26,
      74,
      'hud-icons',
      132,
    );
    assessmentOptionsContainer_m.add(autocompleteAssessmentButton_m);

    // clickPrompt_m
    const clickPrompt_m = this.add.container(0, 0);
    clickPrompt_m.visible = false;
    mobileView.add(clickPrompt_m);

    // visualBacking_1_m
    const visualBacking_1_m = this.add.image(0, 0, '1x1sprite');
    visualBacking_1_m.scaleX = 1024;
    visualBacking_1_m.scaleY = 768;
    visualBacking_1_m.setOrigin(0, 0);
    visualBacking_1_m.tintTopLeft = 985612;
    visualBacking_1_m.tintTopRight = 985612;
    visualBacking_1_m.tintBottomLeft = 985612;
    visualBacking_1_m.tintBottomRight = 985612;
    clickPrompt_m.add(visualBacking_1_m);

    // uIBlocker_2_m
    const uIBlocker_2_m = new UIBlocker(this, 0, 0);
    clickPrompt_m.add(uIBlocker_2_m);

    // clickContainer_m
    const clickContainer_m = this.add.container(512, 384);
    clickPrompt_m.add(clickContainer_m);

    // clickText_m
    const clickText_m = this.add.bitmapText(
      0,
      -176,
      'Aronui',
      'Click on the letters to create the word',
    );
    clickText_m.setOrigin(0.5, 0.5);
    clickText_m.tintTopLeft = 15091001;
    clickText_m.tintTopRight = 15091001;
    clickText_m.tintBottomLeft = 15091001;
    clickText_m.tintBottomRight = 15091001;
    clickText_m.text = 'Click on the letters to create the word';
    clickText_m.fontSize = -30;
    clickContainer_m.add(clickText_m);

    // startButton2_m
    const startButton2_m = new DefaultButton(this, 0, 184);
    clickContainer_m.add(startButton2_m);

    // switchContainer_1_m
    const switchContainer_1_m = this.add.container(1024, 768);
    clickPrompt_m.add(switchContainer_1_m);

    // switchprompt_1_m
    const switchprompt_1_m = this.add.bitmapText(
      -472,
      -60,
      'Aronui',
      'Want to type your answers?\nClick here to switch to keyboard:',
    );
    switchprompt_1_m.tintTopLeft = 15130076;
    switchprompt_1_m.tintTopRight = 15130076;
    switchprompt_1_m.tintBottomLeft = 15130076;
    switchprompt_1_m.tintBottomRight = 15130076;
    switchprompt_1_m.text =
      'Want to type your answers?\nClick here to switch to keyboard:';
    switchprompt_1_m.fontSize = -16;
    switchContainer_1_m.add(switchprompt_1_m);

    // switchToKeyboardButton_m
    const switchToKeyboardButton_m = new DefaultButton(this, -112, -44);
    switchContainer_1_m.add(switchToKeyboardButton_m);

    // keyboardPrompt_m
    const keyboardPrompt_m = this.add.container(0, 0);
    keyboardPrompt_m.visible = false;
    mobileView.add(keyboardPrompt_m);

    // visualBacking_m
    const visualBacking_m = this.add.image(0, 0, '1x1sprite');
    visualBacking_m.scaleX = 1024;
    visualBacking_m.scaleY = 768;
    visualBacking_m.setOrigin(0, 0);
    visualBacking_m.tintTopLeft = 985612;
    visualBacking_m.tintTopRight = 985612;
    visualBacking_m.tintBottomLeft = 985612;
    visualBacking_m.tintBottomRight = 985612;
    keyboardPrompt_m.add(visualBacking_m);

    // uIBlocker_1_m
    const uIBlocker_1_m = new UIBlocker(this, 0, 0);
    keyboardPrompt_m.add(uIBlocker_1_m);

    // keyboardContainer_m
    const keyboardContainer_m = this.add.container(512, 384);
    keyboardPrompt_m.add(keyboardContainer_m);

    // keyboard-image_m
    const keyboard_image_m = this.add.image(0, 0, 'keyboard');
    keyboardContainer_m.add(keyboard_image_m);

    // keyboard-text_m
    const keyboard_text_m = this.add.bitmapText(
      0,
      -176,
      'Aronui',
      'Type your answers on the keyboard',
    );
    keyboard_text_m.setOrigin(0.5, 0.5);
    keyboard_text_m.alpha = 0.65;
    keyboard_text_m.alphaTopLeft = 0.65;
    keyboard_text_m.alphaTopRight = 0.65;
    keyboard_text_m.alphaBottomLeft = 0.65;
    keyboard_text_m.alphaBottomRight = 0.65;
    keyboard_text_m.tintTopLeft = 15091001;
    keyboard_text_m.tintTopRight = 15091001;
    keyboard_text_m.tintBottomLeft = 15091001;
    keyboard_text_m.tintBottomRight = 15091001;
    keyboard_text_m.text = 'Type your answers on the keyboard';
    keyboard_text_m.fontSize = -30;
    keyboardContainer_m.add(keyboard_text_m);

    // startButton1_m
    const startButton1_m = new DefaultButton(this, 0, 184);
    keyboardContainer_m.add(startButton1_m);

    // switchContainer_m
    const switchContainer_m = this.add.container(1024, 768);
    keyboardPrompt_m.add(switchContainer_m);

    // switchprompt_m
    const switchprompt_m = this.add.bitmapText(
      -472,
      -60,
      'Aronui',
      "Don't have a keyboard?\nClick here to switch to letter cards:",
    );
    switchprompt_m.tintTopLeft = 15130076;
    switchprompt_m.tintTopRight = 15130076;
    switchprompt_m.tintBottomLeft = 15130076;
    switchprompt_m.tintBottomRight = 15130076;
    switchprompt_m.text =
      "Don't have a keyboard?\nClick here to switch to letter cards:";
    switchprompt_m.fontSize = -16;
    switchContainer_m.add(switchprompt_m);

    // switchToMouseButton_m
    const switchToMouseButton_m = new DefaultButton(this, -112, -44);
    switchContainer_m.add(switchToMouseButton_m);

    // quitToMenuModal_m
    const quitToMenuModal_m = new QuitToMenuModal(this, 0, 0);
    quitToMenuModal_m.visible = false;
    mobileView.add(quitToMenuModal_m);

    // definitionExampleView_m
    const definitionExampleView_m = new DefinitionExampleView(this, 0, 0);
    mobileView.add(definitionExampleView_m);

    // repeatInstructionButton (prefab fields)
    repeatInstructionButton.useAlternateTextures = false;

    // playDefinitionButton (prefab fields)
    playDefinitionButton.useAlternateTextures = false;

    // playWordInSentenceButton (prefab fields)
    playWordInSentenceButton.useAlternateTextures = false;

    // quitButton (prefab fields)
    quitButton.useAlternateTextures = false;

    // helpButton (prefab fields)
    helpButton.useAlternateTextures = false;

    // switchControlsButton (prefab fields)
    switchControlsButton.useAlternateTextures = false;

    // switchContextButton (prefab fields)
    switchContextButton.buttonText = 'Switch!';

    // settingsButton (prefab fields)
    settingsButton.useAlternateTextures = false;

    // startButton2 (prefab fields)
    startButton2.buttonText = 'Start';

    // switchToKeyboardButton (prefab fields)
    switchToKeyboardButton.buttonText = 'Switch';

    // startButton1 (prefab fields)
    startButton1.buttonText = 'Start';

    // switchToMouseButton (prefab fields)
    switchToMouseButton.buttonText = 'Switch';

    // repeatInstructionButton_m (prefab fields)
    repeatInstructionButton_m.useAlternateTextures = false;

    // playDefinitionButton_m (prefab fields)
    playDefinitionButton_m.useAlternateTextures = false;

    // playWordInSentenceButton_m (prefab fields)
    playWordInSentenceButton_m.useAlternateTextures = false;

    // quitButton_m (prefab fields)
    quitButton_m.useAlternateTextures = false;

    // helpButton_m (prefab fields)
    helpButton_m.useAlternateTextures = false;

    // switchControlsButton_m (prefab fields)
    switchControlsButton_m.useAlternateTextures = false;

    // switchContextButton_m (prefab fields)
    switchContextButton_m.buttonText = 'Switch!';

    // settingsButton_m (prefab fields)
    settingsButton_m.useAlternateTextures = false;

    // startButton2_m (prefab fields)
    startButton2_m.buttonText = 'Start';

    // switchToKeyboardButton_m (prefab fields)
    switchToKeyboardButton_m.buttonText = 'Switch';

    // startButton1_m (prefab fields)
    startButton1_m.buttonText = 'Start';

    // switchToMouseButton_m (prefab fields)
    switchToMouseButton_m.buttonText = 'Switch';

    this.submitButton = submitButton;
    this.repeatInstructionButton = repeatInstructionButton;
    this.playDefinitionButton = playDefinitionButton;
    this.playWordInSentenceButton = playWordInSentenceButton;
    this.userButtons = userButtons;
    this.handDropSite = handDropSite;
    this.handArea = handArea;
    this.playerTypingInput = playerTypingInput;
    this.typingView = typingView;
    this.boardDropSite = boardDropSite;
    this.cardView = cardView;
    this.boardArea = boardArea;
    this.quitButton = quitButton;
    this.helpButton = helpButton;
    this.switchControlsButton = switchControlsButton;
    this.switchContextButton = switchContextButton;
    this.switchToMousePrompt = switchToMousePrompt;
    this.switchToKeyboardPrompt = switchToKeyboardPrompt;
    this.helpContainer = helpContainer;
    this.settingsButton = settingsButton;
    this.autocompleteAssessmentButton = autocompleteAssessmentButton;
    this.assessmentOptionsContainer = assessmentOptionsContainer;
    this.visualBacking_1 = visualBacking_1;
    this.startButton2 = startButton2;
    this.clickContainer = clickContainer;
    this.switchContainer_1 = switchContainer_1;
    this.clickPrompt = clickPrompt;
    this.visualBacking = visualBacking;
    this.startButton1 = startButton1;
    this.keyboardContainer = keyboardContainer;
    this.switchContainer = switchContainer;
    this.keyboardPrompt = keyboardPrompt;
    this.quitToMenuModal = quitToMenuModal;
    this.switchControlsModal = switchControlsModal;
    this.definitionExampleView = definitionExampleView;
    this.desktopView = desktopView;
    this.submitButton_m = submitButton_m;
    this.repeatInstructionButton_m = repeatInstructionButton_m;
    this.playDefinitionButton_m = playDefinitionButton_m;
    this.playWordInSentenceButton_m = playWordInSentenceButton_m;
    this.userButtons_m = userButtons_m;
    this.handDropSite_m = handDropSite_m;
    this.handArea_m = handArea_m;
    this.playerTypingInput_m = playerTypingInput_m;
    this.typingView_m = typingView_m;
    this.boardDropSite_m = boardDropSite_m;
    this.cardView_m = cardView_m;
    this.boardArea_m = boardArea_m;
    this.quitButton_m = quitButton_m;
    this.helpButton_m = helpButton_m;
    this.switchControlsButton_m = switchControlsButton_m;
    this.switchContextButton_m = switchContextButton_m;
    this.switchToMousePrompt_m = switchToMousePrompt_m;
    this.switchToKeyboardPrompt_m = switchToKeyboardPrompt_m;
    this.helpContainer_m = helpContainer_m;
    this.settingsButton_m = settingsButton_m;
    this.autocompleteAssessmentButton_m = autocompleteAssessmentButton_m;
    this.assessmentOptionsContainer_m = assessmentOptionsContainer_m;
    this.visualBacking_1_m = visualBacking_1_m;
    this.startButton2_m = startButton2_m;
    this.clickContainer_m = clickContainer_m;
    this.switchContainer_1_m = switchContainer_1_m;
    this.clickPrompt_m = clickPrompt_m;
    this.visualBacking_m = visualBacking_m;
    this.startButton1_m = startButton1_m;
    this.keyboardContainer_m = keyboardContainer_m;
    this.switchContainer_m = switchContainer_m;
    this.keyboardPrompt_m = keyboardPrompt_m;
    this.quitToMenuModal_m = quitToMenuModal_m;
    this.definitionExampleView_m = definitionExampleView_m;
    this.mobileView = mobileView;

    this.events.emit('scene-awake');
  }

  public submitButton!: DefaultButton;
  public repeatInstructionButton!: HUDButton;
  public playDefinitionButton!: HUDButton;
  public playWordInSentenceButton!: HUDButton;
  public userButtons!: Phaser.GameObjects.Container;
  public handDropSite!: SequencedCardDropSite;
  public handArea!: Phaser.GameObjects.Container;
  public playerTypingInput!: PlayerTypingInput;
  public typingView!: Phaser.GameObjects.Container;
  public boardDropSite!: SequencedCardDropSite;
  public cardView!: Phaser.GameObjects.Container;
  public boardArea!: Phaser.GameObjects.Container;
  public quitButton!: HUDButton;
  public helpButton!: HUDButton;
  public switchControlsButton!: HUDButton;
  public switchContextButton!: DefaultButton;
  public switchToMousePrompt!: Phaser.GameObjects.Container;
  public switchToKeyboardPrompt!: Phaser.GameObjects.Container;
  public helpContainer!: Phaser.GameObjects.Container;
  public settingsButton!: HUDButton;
  public autocompleteAssessmentButton!: HUDButton;
  public assessmentOptionsContainer!: Phaser.GameObjects.Container;
  public visualBacking_1!: Phaser.GameObjects.Image;
  public startButton2!: DefaultButton;
  public clickContainer!: Phaser.GameObjects.Container;
  public switchContainer_1!: Phaser.GameObjects.Container;
  public clickPrompt!: Phaser.GameObjects.Container;
  public visualBacking!: Phaser.GameObjects.Image;
  public startButton1!: DefaultButton;
  public keyboardContainer!: Phaser.GameObjects.Container;
  public switchContainer!: Phaser.GameObjects.Container;
  public keyboardPrompt!: Phaser.GameObjects.Container;
  public quitToMenuModal!: QuitToMenuModal;
  public switchControlsModal!: SwitchControlsModal;
  public definitionExampleView!: DefinitionExampleView;
  public desktopView!: Phaser.GameObjects.Container;
  public submitButton_m!: DefaultButton;
  public repeatInstructionButton_m!: HUDButton;
  public playDefinitionButton_m!: HUDButton;
  public playWordInSentenceButton_m!: HUDButton;
  public userButtons_m!: Phaser.GameObjects.Container;
  public handDropSite_m!: SequencedCardDropSite;
  public handArea_m!: Phaser.GameObjects.Container;
  public playerTypingInput_m!: PlayerTypingInput;
  public typingView_m!: Phaser.GameObjects.Container;
  public boardDropSite_m!: SequencedCardDropSite;
  public cardView_m!: Phaser.GameObjects.Container;
  public boardArea_m!: Phaser.GameObjects.Container;
  public quitButton_m!: HUDButton;
  public helpButton_m!: HUDButton;
  public switchControlsButton_m!: HUDButton;
  public switchContextButton_m!: DefaultButton;
  public switchToMousePrompt_m!: Phaser.GameObjects.Container;
  public switchToKeyboardPrompt_m!: Phaser.GameObjects.Container;
  public helpContainer_m!: Phaser.GameObjects.Container;
  public settingsButton_m!: HUDButton;
  public autocompleteAssessmentButton_m!: HUDButton;
  public assessmentOptionsContainer_m!: Phaser.GameObjects.Container;
  public visualBacking_1_m!: Phaser.GameObjects.Image;
  public startButton2_m!: DefaultButton;
  public clickContainer_m!: Phaser.GameObjects.Container;
  public switchContainer_1_m!: Phaser.GameObjects.Container;
  public clickPrompt_m!: Phaser.GameObjects.Container;
  public visualBacking_m!: Phaser.GameObjects.Image;
  public startButton1_m!: DefaultButton;
  public keyboardContainer_m!: Phaser.GameObjects.Container;
  public switchContainer_m!: Phaser.GameObjects.Container;
  public keyboardPrompt_m!: Phaser.GameObjects.Container;
  public quitToMenuModal_m!: QuitToMenuModal;
  private definitionExampleView_m!: DefinitionExampleView;
  public mobileView!: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  private _controller: AssessmentUIController;
  get controller() {
    return this._controller;
  }
  override inputHandler?: StudentGameInputHandler | undefined = undefined;
  controlSchemeOverride?: ControllerType;

  preload() {
    this.preloadHelperIcons();
  }

  create() {
    this.editorCreate();
    this.controller.initialize();
  }

  override getScene() {
    return this as Phaser.Scene;
  }

  override getBoardDropSite() {
    return this.boardDropSite;
  }

  override getHandDropSite() {
    return this.handDropSite;
  }

  override getPlayerTypingInputs() {
    return [this.playerTypingInput, this.playerTypingInput_m];
  }

  override getDropSiteFromCard(card: StudentGameCard) {
    return card.origin?.dropSite;
  }

  override getShouldDisplayBoardSlots(): boolean {
    return false;
  }

  override getDefinitionExampleView() {
    return this.definitionExampleView;
  }

  override getDefinitionIconsToLoad() {
    let wordsToLoad: Word[] = [];
    if (this.getAssessmentStudent().doScreener) {
      wordsToLoad.push(...getScreenerWords());
    }
    wordsToLoad.push(...getAssessmentWords(this.getPhase()));
    return wordsToLoad.map((w) => w.spelling);
  }

  override getExampleIconsToLoad() {
    let wordsToLoad: Word[] = [];
    if (this.getAssessmentStudent().doScreener) {
      wordsToLoad.push(...getScreenerWords());
    }
    wordsToLoad.push(...getAssessmentWords(this.getPhase()));
    return wordsToLoad.map((w) => _.kebabCase(w.example));
  }

  override setSubmissionPossible(canSubmit: boolean): void {
    this.submitButton.controller.makeInteractive(canSubmit);
  }

  override getCanSubmit(): boolean {
    return !!this.controller.currentWord && this.getInput().length > 0;
  }

  getAssessmentStudent() {
    const student = GameInstance.instance.assessment?.students[getStudent().id];
    if (!student) throw new Error('Assessment student not found');
    return student;
  }

  getPhase() {
    const assessmentStudent = this.getAssessmentStudent();

    // If we're doing a screener, handle phase specially
    const screenerComplete = !!this.controller.screenerPhase;
    if (assessmentStudent.doScreener && screenerComplete) {
      return this.controller.screenerPhase!;
    } else if (assessmentStudent.doScreener) {
      // allow distractors to be selected from up to phase 2 during screener
      return 2;
    }

    // we're not doing a screener
    return assessmentStudent.phase;
  }

  getControlScheme() {
    if (this.controlSchemeOverride) return this.controlSchemeOverride;
    return this.getAssessmentStudent()?.control || ControllerType.KEYBOARD;
  }

  updateCandidatePlacement(
    dropSite: CardDropSite,
    card: StudentGameCard,
    targetIndex: number,
  ): void {
    this.handDropSite.removeCandidatePlacement();
    this.boardDropSite.removeCandidatePlacement();
    dropSite.displayCandidatePlacement(targetIndex, card);
  }

  setAllDropSitesVisible(visible: boolean) {
    this.handDropSite.zone?.setVisible(visible);
    this.boardDropSite.zone?.setVisible(visible);
  }

  async checkAnswer() {
    // Let the controller deal with this logic.
    this.controller.checkAnswer();
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
